<template>
    <div>
        <h5 class="card-title">{{ $t('redactor.recap-infos') }} :</h5>
        <div class="card-text">
            <ul class="px-4">
                <li class="mb-2">
                    {{ $t('global.keyword') }} :
                    <span id="keyword">
                        {{ writing.related_order.keyword }}
                    </span>
                    <button class="btn p-0 btn-link text-muted" @click="copyToClipboard($event, 'keyword')">
                        <i class="far fa-copy ml-1" />
                    </button>
                </li>

                <li class="mb-2">
                    Title :
                    <span>{{ writing.related_order.meta_title }}</span>
                </li>

                <li class="mb-2">
                    H1 :
                    <span>{{ writing.related_order.tag_title }}</span>
                </li>

                <li class="mb-2">
                    <div class="form-group">
                        <label for="category-select">Catégories</label>
                        <b-select id="category-select" v-model="writing.category" expanded>
                            <option v-for="category in categories" :key="category.id" :value="category.id">
                                {{ category.name }}
                            </option>
                        </b-select>
                    </div>
                </li>

                <li class="mb-2">
                    <div class="form-group">
                        <label for="authors-select">Auteurs</label>
                        <b-select id="authors-select" v-model="writing.author" expanded>
                            <option v-for="author in authors" :key="author.id" :value="author.id">
                                {{ author.nickname }}
                            </option>
                        </b-select>
                    </div>
                </li>

                <li class="mb-2">
                    {{ $t('redactor.nbWords') }} :
                    <span class="text-muted">{{ writing.words_count }}</span>
                </li>

                <li class="mb-2">
                    {{ $t('global.brief') }} :
                    <span class="text-muted">{{ writing.brief }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'RedactorPreorderBriefPanel',

        computed: {
            ...mapState('redactors', {
                writing: state => state.writing,
                categories: state => state.categories,
                authors: state => state.authors
            }),
            isAIPreorder() {
                return this.writing.related_order.type === 'textbulker'
            }
        },

        data: function () {
            return {}
        },

        created() {
            this.autoChooseAuthor()
        },

        methods: {
            autoChooseAuthor() {
                if (this.writing.author === null && this.isAIPreorder) {
                    let authorChoosen = this.authors[(Math.random() * this.authors.length) | 0]
                    while (authorChoosen.nickname === '') {
                        authorChoosen = this.authors[(Math.random() * this.authors.length) | 0]
                    }
                    this.writing.author = authorChoosen.id
                }
            },
            copyToClipboard(e, id) {
                let testingCodeToCopy = document.getElementById(id)
                // testingCodeToCopy.setAttribute('type', 'text');
                // testingCodeToCopy.select();

                try {
                    navigator.clipboard.writeText(testingCodeToCopy.innerText)
                    //document.execCommand('copy');
                    e.currentTarget.querySelector('i').classList.add('text-success')

                    setTimeout(() => {
                        document.querySelectorAll('i').forEach(icon => icon.classList.remove('text-success'))
                    }, 3000)
                } catch (err) {
                    console.error('No copy ' + err)
                }

                testingCodeToCopy.setAttribute('type', 'hidden')
            }
        }
    }
</script>